<template>
	<div
		class="carousel-navigation"
		:class="navigationPosition"
	>
		<helio-icon
			class="carousel-navigation__control carousel-navigation__control--previous"
			:class="{ 'carousel-navigation__control--inactive': !canDecrement }"
			:color="navigation.color || color"
			:token="navigation.previous ? navigation.previous : 'angle-left'"
			weight="light"
			aria-hidden="true"
			@click="decrement"
		/>

		<helio-icon
			class="carousel-navigation__control carousel-navigation__control--next"
			:class="{ 'carousel-navigation__control--inactive': !canIncrement }"
			:color="navigation.color || color"
			:token="navigation.next ? navigation.next : 'angle-right'"
			weight="light"
			aria-hidden="true"
			@click="increment"
		/>
	</div>
</template>

<script>
import Icon from '../../icon/Icon.vue';

export default {
	name: 'Navigation',

	components: {
		'helio-icon': Icon,
	},

	props: {
		color: {
			type: String,
			required: true,
			description: 'Sets color of the control icons if no control specific color is set, same as clickable link in description',
		},

		currentIndex: {
			type: Number,
			required: true,
			description: 'Index of the first active card of the carousel',
		},

		grid: {
			type: Number,
			required: true,
			description: 'Sets how many columns are displayed for each breakpoint',
		},

		gutter: {
			type: Number,
			required: false,
			default: 0,
			description: 'Represent the current gutter between the cards',
		},

		itemsLength: {
			type: Number,
			required: true,
			description: 'Number of cards in the carousel',
		},

		navigation: {
			type: Object,
			required: true,
			description: 'Icons used for controls and control specific colors',
		},
	},

	computed: {
		navigationPosition() {
			return this.navigation.position ? `carousel-navigation--${this.navigation.position}` : '';
		},

		canDecrement() {
			return this.currentIndex > 0;
		},

		canIncrement() {
			return this.currentIndex + this.grid < this.itemsLength;
		},
	},

	methods: {
		decrement() {
			if (this.canDecrement) {
				this.$emit('decrementIndex');
			}
		},

		increment() {
			if (this.canIncrement) {
				this.$emit('incrementIndex');
			}
		},
	},
};
</script>

<style lang="scss" scoped src="./navigation.scss" />
